import React, { useState } from 'react';
import { Input, Icon } from '@b-design/fusion';
import PaginationComponent from '@/components/PaginationComponent';
import CalculateComponent from '@/components/CalculateComponent';
import ArchivedTable from '../archivedTable';
import $i18n from '@/i18n';
import { dataArchived } from './dataArchived.js';

import './index.less';

const Archived: React.FC = () => {
  const [contentHeight, setContentHeight] = useState(296);

  const pageChangeHandler = () => {};
  return (
    <div className="list-content">
      <div className="archived-container">
        <Input
          className="filter-input"
          // style={inputStyle}
          placeholder={$i18n.get({ id: 'aopf.pages.miniapp.input.Search', dm: '搜索...' })}
          // value={filterValue}
          // onChange={(v) => setFilterValue(v)}
          innerBefore={<Icon type="search" style={{ marginTop: 5 }} />}
          // onPressEnter={onSearch}
        />

        <ArchivedTable style={{ height: contentHeight }} dataSource={dataArchived} />

        <PaginationComponent
          // total={tableData.totalCount}
          // current={paginationValue.currentPage}
          // pageSize={paginationValue.pageSize}
          // onPageChange={pageChangeHandler}
          total={0}
          current={0}
          pageSize={10}
          onPageChange={pageChangeHandler}
        />

        <CalculateComponent
          otherWidth={280}
          otherHeight={108 + 80 + 120}
          windowChange={(_width, height) => {
            setContentHeight(height);
          }}
        />
      </div>
    </div>
  );
};

export default Archived;
